import { useState } from 'react'
import { FaSyncAlt } from "react-icons/fa";

function ManualSync(props: any) {
  const [showSpin, setShowSpin] = useState(false);

  return (
    <div className="">
      <button type="button" className="flex btn-manual-sync" onClick={() => props.setShowConfirmSync(true)} onMouseOver={() => setShowSpin(true)} onMouseOut={() => setShowSpin(false)} disabled={props.isDisabled}>
        <FaSyncAlt
          className={`mr-3 ${showSpin ? "animate-spin":''}`}
        />
        Sync
      </button>
    </div>
  );
};
export default ManualSync;